<template>
    <div class="dispatch-sites">
        <DispatchSitesMap />

        <div class="nav-row">
            <DxButton icon="chevronleft" text="Previous" styling-mode="outlined" @click="onPrevious" />
            <DxButton icon="chevronright" text="Next" type="default" styling-mode="contained"
                @click="onNext" />
        </div>
    </div>
</template>

<script>
import { DxButton } from 'devextreme-vue/button';
import DispatchSitesMap from './dispatch-sites-map.vue';

export default {
    name: 'DispatchSites',
    components: {
        DxButton,
        DispatchSitesMap,
    },
    emits: ['previous', 'next'],
    methods: {
        onPrevious() {
            this.$emit('previous');
        },
        onNext() {
            this.$emit('next');
        },
    },
};
</script>

<style scoped>
/* Fill the vertical space below the builder title/stepper, down to the nav row.
   The offset accounts for the app header + the builder's title and stepper. */
.dispatch-sites {
    display: flex;
    flex-direction: column;
    height: calc(100vh - 210px);
    min-height: 440px;
}

/* The picker grows to fill; the nav buttons stay pinned below. */
.dispatch-sites-map {
    flex: 1;
    min-height: 0;
}

.header-block {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
}

h3 {
    margin: 0;
}

.muted {
    color: rgba(150, 150, 150, 0.9);
    font-size: 13px;
    margin: 4px 0 0 0;
}

.nav-row {
    display: flex;
    justify-content: space-between;
    margin: 20px;
    flex-shrink: 0;
}

@media (max-width: 640px) {
    .dispatch-sites {
        height: auto;
    }
}
</style>
